var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSports(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9965 4.49998C7.85631 4.49998 4.50001 7.85627 4.50001 11.9965C4.50001 16.1367 7.85631 19.493 11.9965 19.493C16.1367 19.493 19.493 16.1367 19.493 11.9965C19.493 7.85627 16.1367 4.49998 11.9965 4.49998ZM3.50001 11.9965C3.50001 7.30399 7.30402 3.49998 11.9965 3.49998C16.689 3.49998 20.493 7.30399 20.493 11.9965C20.493 16.689 16.689 20.493 11.9965 20.493C7.30402 20.493 3.50001 16.689 3.50001 11.9965Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25862 5.44147C9.14778 6.99595 10.3538 9.35512 10.3538 11.9965C10.3538 14.6596 9.13311 17.0337 7.22138 18.5883L6.59045 17.8125C8.27784 16.4403 9.35383 14.347 9.35383 11.9965C9.35383 9.66633 8.29117 7.58611 6.62323 6.21367L7.25862 5.44147Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3628 6.21367C15.6948 7.58611 14.6322 9.66633 14.6322 11.9965C14.6322 14.347 15.7082 16.4403 17.3956 17.8125L16.7646 18.5883C14.8529 17.0337 13.6322 14.6596 13.6322 11.9965C13.6322 9.35512 14.8382 6.99595 16.7274 5.44148L17.3628 6.21367Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4965 20V3.99998H12.4965V20H11.4965Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 12.4965H4.00001V11.4965H20V12.4965Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSports);
export default __webpack_public_path__ + "static/media/sports.ea9352c9f7d32b708b969d92525c2842.svg";
export { ForwardRef as ReactComponent };